// PROTOTYPE: one hardcoded image stands in for per-room imagery (rendered for one demo unit of the
// `mvb-baukultur-winkelbauer` project). It's used both by the options-tab "Start customization" CTA
// and as the visual for immersive rooms that have no 3D visualization. Replace with real per-room
// imagery when productionizing — the room is the natural carrier (`ConfiguratorRoomDto` in
// `@/services/configurator`).
export const ROOM_PLACEHOLDER_IMAGE_URL =
    'https://db9mtu2ne9hym.cloudfront.net/v2/mvb-baukultur-winkelbauer-wohnzimmer/combine?room=01_01&drgw=01_01&dsp=05_01&fg=01_01&it=01_01&pk=02_01&schp=01_01&sl=03_01';
